<template>
  <div class="titlebar-drag flex justify-between items-center pe-10 ps-6 w-full pt-5">
    <div class="flex items-center gap-4">
      <Button class="!bg-white text-black ms-6" @click="setIsCollapsed(!isCollapsed)">
        <v-icon>{{ "mdi-menu" }}</v-icon>
      </Button>
      <Image :src="logo" imageClass="w-24" />
      <label class="text-xl text-primary-500">{{
        title ? $t(`layouts.${title}`) : ""
      }}</label>
    </div>

    <div class="flex gap-2 items-center">
      <div class="flex flex-col items-end gap-2">
        <label class="text-sm text-primary-900">{{ fullname }}</label>
        <Button :class="[
          'rounded-lg flex text-sm',
          {
            '!text-primary-500': status == 1 && isConnected,
            '!text-yellow-700': status == 2,
            'text-red': status == 3,
          },
        ]" @click="toggle">
          <div :class="[
            'w-3 h-3 rounded-full',
            `${status == 3
              ? 'bg-red-500'
              : status == 2
                ? 'bg-yellow-500'
                : 'bg-green-600 animate-pulse'
            }`,
          ]" />
          <label class="text-xs text-primary-900">{{
            status == 1
              ? isConnected
                ? $t("home.agent_status.online_status")
                : $t("home.agent_status.offline_status")
              : status == 2
                ? $t("home.agent_status.rest_status")
                : $t("home.agent_status.busy_status")
          }}</label>
          <!-- <p v-if="status == 2" class="bg-yellow-100 text-xs rounded-lg">
            {{ getRemainingTime() }}
          </p> -->
        </Button>

        <Popover ref="statusPopover" :class="[
          {
            'before:bottom-full before:left-5 before:h-0 before:w-0 before:absolute before:pointer-events-none after:bottom-full after:left-5 after:h-0 after:w-0 after:absolute after:pointer-events-none':
              $i18n.locale == 'ar',
            ' before:bottom-full before:right-5 before:h-0 before:w-0 before:absolute before:pointer-events-none after:bottom-full after:right-5 after:h-0 after:w-0 after:absolute after:pointer-events-none':
              $i18n.locale == 'en',
          },
        ]">
          <AgentStatusSelect :style="$i18n.locale == 'ar' ? 'direction: rtl;' : 'direction: ltr;'
            " />
        </Popover>
      </div>
      <RouterLink :to="getbaseURL + '/Profile'" class="flex gap-2 align-center gap-2">
        <Avatar class="mr-2 bg-light-grey" size="large" shape="circle"
          :image="avatar ? avatar : require('@/assets/user.png')"></Avatar>
      </RouterLink>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from "vuex";
import "/node_modules/flag-icons/css/flag-icons.min.css";
import { Avatar, Button, Popover, Image } from "primevue";
import AgentStatusSelect from "@/pages/agent/dashboard/components/AgentStatusSelect.vue";

export default {
  name: "NavBar",
  components: {
    Avatar,
    Button,
    Popover,
    AgentStatusSelect,
    Image,
  },
  props: {
    title: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      loading: false,
      error: "",
      remainingTime: "00:00",
      timer: null,
    };
  },
  methods: {
    ...mapActions(["SetMessageDialog", "ShowProgressBar"]),
    ...mapMutations(["setLang", "setIsCollapsed"]),
    hasPermisson(permission) {
      if (!this.permissions) {
        return false;
      }
      return this.permissions.includes(permission);
    },
    changeLocale(locale) {
      const html = document.documentElement;
      html.dir = locale === "ar" ? "rtl" : "ltr";
      this.$vuetify.locale.current = locale;
      this.setLang(locale);
    },
    getRemainingTime() {
      if (!this.timer) {
        this.timer = setInterval(() => {
          const endTime = new Date(parseInt(this.restEndtime));
          const now = new Date();
          const diff = endTime - now;
          if (diff <= 0) {
            clearInterval(this.timer);
            this.timer = null;
            this.remainingTime = "00:00";
          }
          this.remainingTime = this.formatTime(diff);
        }, 1000);
      }
      return this.remainingTime;
    },
    formatTime(ms) {
      const seconds = Math.floor((ms / 1000) % 60)
        .toString()
        .padStart(2, "0");
      const minutes = Math.floor((ms / 1000 / 60) % 60)
        .toString()
        .padStart(2, "0");
      return `${minutes}:${seconds}`;
    },
    toggle(event) {
      this.$refs.statusPopover.toggle(event);
    },
  },
  computed: {
    ...mapGetters([
      "getbaseURL",
      "permissions",
      "status",
      "isConnected",
      "homePermission",
      "smsPermission",
      "phonePermission",
      "fullname",
      "logos",
      "inCall",
      "notReadChatMessages",
      "avatar",
      "isConnected",
      "restEndtime",
      "logos",
      "isCollapsed",
    ]),
    currentLocal() {
      return this.$vuetify.locale.current;
    },
    logo() {
      const logosList = JSON.parse(this.logos);
      if (
        !logosList ||
        !logosList?.menu_logo ||
        logosList?.menu_logo == ""
      ) {
        return require("../assets/go_ucaas_logo.png");
      }
      return logosList.menu_logo;
    },
  },
};
</script>

<style></style>
